import Home from './Home.data-manager-stags-versions-edit.vue'

export default {
  Home
}